import React from "react";
import {
  Dialog,
  DialogContainer,
  Heading,
  Content,
  View,
  Text,
  Flex,
  Button,
  Divider,
} from "@adobe/react-spectrum";
import CheckmarkCircleOutline  from "@spectrum-icons/workflow/CheckmarkCircleOutline";

interface CallbackSuccessCardProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  details?: {
    timezone?: string;
    date?: string;
    timeslot?: string;
    reason?: string;
    agentName?: string;
  };
  type?: 'reschedule' | 'reassign' | 'cancel' | 'general';
  autoCloseDuration?: number; // in milliseconds, 0 means no auto close
  prevAgentName?: string;
  newAgentName?: string;
}

const CallbackSuccessCard: React.FC<CallbackSuccessCardProps> = ({
  isOpen= true,
  onClose,
  title,
  subtitle,
  details,
  type = 'general',
  autoCloseDuration = 0,
  prevAgentName,
}) => {
  // Auto close functionality
  React.useEffect(() => {
    if (isOpen && autoCloseDuration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseDuration);

      return () => clearTimeout(timer);
    }
  }, [isOpen, autoCloseDuration, onClose]);

  // const getIconColor = () => {
  //   switch (type) {
  //     case 'reschedule':
  //       return '#a15e7e'; // Pink/magenta color as shown in the image
  //     case 'reassign':
  //       return '#a15e7e'; // Blue
  //     case 'cancel':
  //       return '#dc2626'; // Red
  //     default:
  //       return '#16a34a'; // Green
  //   }
  // };

  // const getBackgroundColor = () => {
  //   switch (type) {
  //     case 'reschedule':
  //       return '#a15e7e'; // Pink/magenta header
  //     case 'reassign':
  //       return '#a15e7e'; // Blue header
  //     case 'cancel':
  //       return '#dc2626'; // Red header
  //     default:
  //       return '#16a34a'; // Green header
  //   }
  // };

  return (
    <DialogContainer onDismiss={onClose}>
      {isOpen && (
        <Dialog 
          size="M" 
          // UNSAFE_className="callback-success-card"
          // UNSAFE_style={{
          //   borderRadius: '12px',
          //   boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
          //   overflow: 'hidden',
          //   padding: 0,
          // }}
        >
          {/* Header Section */}
          <View 
            UNSAFE_style={{
              backgroundColor: "green",
              padding: '20px 24px',
              textAlign: 'center',
            //   borderRadius: '12px 12px 0 0'
            width: '480px'
            }}
          >
            <Heading 
              level={4}
              UNSAFE_style={{
                color: 'white',
                fontSize: '18px',
                fontWeight: '600',
                margin: 0,
                lineHeight: '1.4'

              }}
            >
              {title}
            </Heading>
          </View>

          <Content>
            <View >
              {/* Success Icon */}
              <Flex justifyContent="center" marginBottom="size-300">
                <View
                  UNSAFE_style={{
                    width: '64px',
                    height: '64px',
                    borderRadius: '50%',
                    // backgroundColor: getIconColor(),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CheckmarkCircleOutline size="XXL"  UNSAFE_style={{color: 'green'}}/>
                </View>
              </Flex>

              {/* Subtitle */}
              {subtitle && (
                <Text 
                  UNSAFE_style={{
                    fontSize: '14px',
                    fontWeight: '400',
                    color: '#222222',
                    textAlign: 'left',
                    marginBottom: '20px',
                    display: 'block'
                  }}
                >
                  {subtitle}
                </Text>
              )}

              {/* Details Section */}
              {details && (
                <View 
                  marginBottom="size-300"
                  UNSAFE_style={{
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    // padding: '16px'
                  }}
                >
                  <Flex direction={"row"} gap={"size-150"} justifyContent="space-between">
                  {details.timezone && (
                    <Flex direction={"column"} marginBottom="size-150">
                      <Text UNSAFE_style={{ fontSize: '12px',  color: '#464646' }}>
                        Customer Timezone
                      </Text>
                      <Text UNSAFE_style={{ fontSize: '14px', color: '#333' }}>
                        {details.timezone}
                      </Text>
                    </Flex>
                  )}
                  
                  {details.date && (
                    <Flex direction={"column"} marginBottom="size-150">
                      <Text UNSAFE_style={{ fontSize: '12px',  color: '#464646' }}>
                        Selected Date
                      </Text>
                      <Text UNSAFE_style={{ fontSize: '14px', color: '#333' }}>
                        {details.date}
                      </Text>
                    </Flex>
                  )}
                  
                  {details.timeslot && (
                    <Flex direction={"column"} marginBottom="size-150">
                      <Text UNSAFE_style={{ fontSize: '12px',  color: '#464646' }}>
                        Selected Timeslot
                      </Text>
                      <Text UNSAFE_style={{ fontSize: '14px', color: '#333' }}>
                        {details.timeslot}
                      </Text>
                    </Flex>
                  )}
                  </Flex>

                  {details.agentName && (
                   <>
                   <Flex direction={"row"} justifyContent="space-between" marginBottom="size-150">
                      <Flex direction={"column"}>
                      <Text UNSAFE_style={{ fontSize: '12px', color: '#464646' }}>
                        Previously Assigned to
                      </Text>
                      <Text UNSAFE_style={{ fontSize: '14px', color: '#333' }}>
                        {prevAgentName || "-"}
                      </Text>
                      </Flex>
                      <Flex direction={"column"} justifyContent="space-between" marginBottom="size-150">
                      <Text UNSAFE_style={{ fontSize: '12px',  color: '#464646' }}>
                       Now Assigned to
                      </Text>
                      <Text UNSAFE_style={{ fontSize: '14px', color: '#333' }}>
                        {details.agentName}
                      </Text>
                    </Flex>
                    </Flex>
                   
                    
                    </>
                  )}
                  
                  {details.reason && (
                    <View marginTop="size-150">
                      <Text 
                        UNSAFE_style={{ 
                          fontSize: '12px', 
                          color: '#464646',
                          // marginBottom: '8px',
                          display: 'block'
                        }}
                      >
                        Reason for {type}
                      </Text>
                      <Text 
                        UNSAFE_style={{ 
                          fontSize: '14px', 
                          color: '#333',
                          lineHeight: '1.5',
                        }}
                      >
                        {details.reason}
                      </Text>
                    </View>
                  )}
                </View>
              )}
              {/* <Divider marginBottom="size-0" UNSAFE_style={{ borderColor: '#e0e0e0' }} /> */}

              {/* Close Button */}
              <Flex justifyContent="end">
                <Button 
                  variant="primary"
                  onPress={onClose}
                  UNSAFE_style={{
                    // borderRadius: '6px',
                    minWidth: '100px',
                    fontWeight: '500'
                  }}
                >
                  Close
                </Button>
              </Flex>
            </View>
          </Content>
        </Dialog>
      )}
    </DialogContainer>
  );
};

export default CallbackSuccessCard;
